module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.c645b557.png";